import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { LOCALES, TRANSLATIONS } from "@/i18n/translations";

const LangCtx = createContext({ locale: "en", setLocale: () => {}, t: (k) => k, dir: "ltr" });
const KEY = "parking_escape_locale";

export function LanguageProvider({ children }) {
  const [locale, setLocaleState] = useState(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem(KEY) : null;
    if (saved && TRANSLATIONS[saved]) return saved;
    // Auto-detect from browser
    const nav = (typeof navigator !== "undefined" && (navigator.language || "")).slice(0, 2).toLowerCase();
    if (TRANSLATIONS[nav]) return nav;
    return "en";
  });

  const setLocale = (code) => {
    if (!TRANSLATIONS[code]) return;
    localStorage.setItem(KEY, code);
    setLocaleState(code);
  };

  const meta = LOCALES.find((l) => l.code === locale) || LOCALES[0];

  useEffect(() => {
    document.documentElement.lang = locale;
    document.documentElement.dir = meta.dir;
  }, [locale, meta.dir]);

  const t = useMemo(() => {
    return (key, vars) => {
      const parts = key.split(".");
      let node = TRANSLATIONS[locale];
      let fallback = TRANSLATIONS.en;
      for (const p of parts) {
        node = node && node[p];
        fallback = fallback && fallback[p];
      }
      let str = (typeof node === "string" ? node : fallback) || key;
      if (vars) {
        for (const [k, v] of Object.entries(vars)) {
          str = str.replaceAll(`{${k}}`, v);
        }
      }
      return str;
    };
  }, [locale]);

  return (
    <LangCtx.Provider value={{ locale, setLocale, t, dir: meta.dir }}>
      {children}
    </LangCtx.Provider>
  );
}

export function useT() {
  return useContext(LangCtx);
}

export { LOCALES };
